import { useMemo } from 'react';
import { TableRowActionsMenu } from '@dealstack/frontend/shared/components/TableRowActionsMenu/TableRowActionsMenu';
import { TableRowActionOption } from '@dealstack/frontend/shared/components/TableRowActionsMenu/TableRowActionsMenu.types';
import { useTranslationOrganization } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

interface Props {
	onEdit: () => void;
	onDelete: () => void;
}

export const OrganizationRowActions = ({ onEdit }: Props) => {
	const tOrganization = useTranslationOrganization();

	const options: TableRowActionOption[] = useMemo(() => {
		return [
			{
				label: tOrganization('organizations_management.row_actions.edit'),
				onClick: onEdit,
			},
			// todo: Needs further clarification re constraints for deletion. Disabling for now
			// {
			// 	label: tOrganization('organizations_management.row_actions.delete'),
			// 	onClick: onDelete,
			// },
		];
	}, [tOrganization, onEdit]);

	return <TableRowActionsMenu options={options} />;
};
